import Reveal from '@/components/base/Reveal';

const sessions = [
  { name: 'SYDNEY', window: 'Early hours', active: false },
  { name: 'TOKYO', window: 'Asian session', active: false },
  { name: 'LONDON', window: 'Peak liquidity', active: true },
  { name: 'NEW YORK', window: 'US overlap', active: true },
];

const standDown = [
  'Thin, low-liquidity hours where moves cannot be trusted',
  'Sharp news-driven spikes — the system will not chase the first candle',
  'Choppy, directionless ranges that offer no clean level to work from',
  'Any moment the conditions simply fail to line up',
];

function TradingSession() {
  return (
    <section
      id="trading-session"
      className="w-full scroll-mt-[124px] px-4 md:px-8 lg:px-12 py-16 md:py-24"
    >
      <div className="max-w-[1200px] mx-auto">
        <Reveal>
          <div className="flex items-center gap-3 mb-5">
            <span className="text-[11px] font-data tracking-[0.24em] text-primary-600">
              STRATEGY
            </span>
            <span className="w-8 h-px bg-primary-400"></span>
            <span className="text-[11px] font-data tracking-[0.2em] text-foreground-400">
              TIMING
            </span>
          </div>
          <h2 className="font-heading font-extrabold tracking-tight text-foreground-950 text-[32px] leading-[1.08] sm:text-[42px] lg:text-[46px] max-w-[720px]">
            When The System Steps Aside.
          </h2>
          <p className="mt-5 text-[15px] md:text-base leading-relaxed text-foreground-600 max-w-[640px]">
            Gold is not equally tradable at every hour. The strategy concentrates on the sessions
            where liquidity is real and moves tend to carry — and stands down when the market is
            thin or erratic.
          </p>
        </Reveal>

        <Reveal delay={120} className="mt-10">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
            {sessions.map((session) => (
              <div
                key={session.name}
                className={`rounded-lg border px-4 py-4 ${
                  session.active
                    ? 'border-primary-300 bg-primary-50'
                    : 'border-background-300 bg-background-50'
                }`}
              >
                <div className="flex items-center justify-between">
                  <span
                    className={`font-data text-[12px] tracking-[0.16em] ${
                      session.active ? 'text-primary-700' : 'text-foreground-500'
                    }`}
                  >
                    {session.name}
                  </span>
                  <span
                    className={`w-2 h-2 rounded-full ${
                      session.active ? 'bg-primary-500 breathe' : 'bg-foreground-300'
                    }`}
                  ></span>
                </div>
                <p
                  className={`mt-2 text-[11.5px] ${
                    session.active ? 'text-foreground-700' : 'text-foreground-400'
                  }`}
                >
                  {session.window}
                </p>
                <p
                  className={`mt-3 font-data text-[10px] tracking-widest ${
                    session.active ? 'text-primary-600' : 'text-foreground-400'
                  }`}
                >
                  {session.active ? 'PRIMARY WINDOW' : 'QUIET'}
                </p>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={180}>
          <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="rounded-lg border border-secondary-200 bg-secondary-100/70 px-6 py-6">
              <div className="flex items-center gap-3">
                <span className="w-9 h-9 rounded-lg bg-secondary-200 flex items-center justify-center shrink-0">
                  <i className="ri-time-line text-[17px] text-secondary-900"></i>
                </span>
                <p className="font-heading font-bold text-foreground-950 text-[15px]">
                  Where it trades
                </p>
              </div>
              <p className="mt-3 text-[13.5px] leading-relaxed text-foreground-600">
                The system favours the London and New York windows, when participation is highest
                and the gold market is most responsive. Activity in the quieter Asian hours is
                treated with more caution, not as an open invitation.
              </p>
            </div>

            <div className="rounded-lg border border-accent-200 bg-accent-100/70 px-6 py-6">
              <div className="flex items-center gap-3">
                <span className="w-9 h-9 rounded-lg bg-accent-200 flex items-center justify-center shrink-0">
                  <i className="ri-pause-circle-line text-[17px] text-accent-900"></i>
                </span>
                <p className="font-heading font-bold text-foreground-950 text-[15px]">
                  When it stands down
                </p>
              </div>
              <ul className="mt-3 space-y-2">
                {standDown.map((item) => (
                  <li key={item} className="flex items-start gap-2.5">
                    <i className="ri-subtract-line text-[13px] text-accent-700 mt-0.5 shrink-0"></i>
                    <span className="text-[13px] leading-relaxed text-foreground-600">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Reveal>

        <Reveal delay={220}>
          <p className="mt-8 text-center text-[13px] text-foreground-500">
            No setup means no trade. Sitting out is a decision the system makes on purpose — not a
            failure to find one.
          </p>
        </Reveal>
      </div>
    </section>
  );
}

export default TradingSession;